"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[533],{

/***/ 70533:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(25675);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_image__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var src_utils_loader__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(52937);
/* harmony import */ var _chakra_ui_react__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(48641);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(85893);







const Article = ({
  excerpt,
  image,
  target
}) => /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsxs)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_3__/* .Container */ .W2, {
  children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_3__/* .Box */ .xu, {
    h: "2.75rem",
    w: "12.75rem",
    mx: "auto",
    mb: -5,
    pos: "relative",
    borderRadius: 4,
    overflow: "hidden",
    bg: "baseWhite",
    borderColor: "borders.grey",
    borderWidth: "1px",
    boxShadow: "shadows.cards",
    children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_1___default()), {
      loader: src_utils_loader__WEBPACK_IMPORTED_MODULE_4__/* .imageLoader */ .X,
      unoptimized: true,
      src: image.url,
      loading: "lazy",
      decoding: "async",
      layout: "fill",
      className: "imagePadding10"
    })
  }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("a", {
    href: target,
    title: excerpt,
    target: "_blank",
    rel: "noreferrer",
    children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_3__/* .Box */ .xu, {
      w: "full",
      bg: "baseWhite",
      rounded: "md",
      p: "xl",
      borderRadius: 4,
      overflow: "hidden",
      borderColor: "borders.grey",
      borderWidth: "1px",
      boxShadow: "shadows.cards",
      h: "12rem",
      children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_3__/* .Stack */ .Kq, {
        children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_3__/* .Text */ .xv, {
          fontFamily: "Montserrat-Medium",
          fontSize: ".875rem",
          color: "baseDark",
          lineHeight: "18px",
          mt: {
            base: 0,
            md: '1.3rem'
          },
          children: excerpt
        })
      })
    })
  })]
});

/* harmony default export */ __webpack_exports__["default"] = (Article);

/***/ })

}]);